<template>
    <div>
        <div class="fab-container">
            <div  :class="`button iconbutton tw-text-2xl ${openOptions ? 'active' : ''}`" @click="openOptions = !openOptions">
                <i class="fa fa-plus tw-rounded-full tw-shadow-xl"></i>
            </div>
            <div :class="`options ${openOptions ? 'active' : ''}`">
                <ul v-if="button.line_oa || button.tel || button.facebook">
                    <li v-if="button.line_oa">
                        <a class="iconbutton-line tw-text-center" :href="button.line_oa" target="__blank">
                            <svg xmlns="http://www.w3.org/2000/svg" 
                                width="26" 
                                height="26" 
                                fill="currentColor" 
                                class="bi bi-line icon-button" 
                                viewBox="0 0 16 16">
                                    <path d="M8 0c4.411 0 8 2.912 8 6.492 0 1.433-.555 2.723-1.715 3.994-1.678 1.932-5.431 4.285-6.285 4.645-.83.35-.734-.197-.696-.413l.003-.018.114-.685c.027-.204.055-.521-.026-.723-.09-.223-.444-.339-.704-.395C2.846 12.39 0 9.701 0 6.492 0 2.912 3.59 0 8 0ZM5.022 7.686H3.497V4.918a.156.156 0 0 0-.155-.156H2.78a.156.156 0 0 0-.156.156v3.486c0 .041.017.08.044.107v.001l.002.002.002.002a.154.154 0 0 0 .108.043h2.242c.086 0 .155-.07.155-.156v-.56a.156.156 0 0 0-.155-.157Zm.791-2.924a.156.156 0 0 0-.156.156v3.486c0 .086.07.155.156.155h.562c.086 0 .155-.07.155-.155V4.918a.156.156 0 0 0-.155-.156h-.562Zm3.863 0a.156.156 0 0 0-.156.156v2.07L7.923 4.832a.17.17 0 0 0-.013-.015v-.001a.139.139 0 0 0-.01-.01l-.003-.003a.092.092 0 0 0-.011-.009h-.001L7.88 4.79l-.003-.002a.029.029 0 0 0-.005-.003l-.008-.005h-.002l-.003-.002-.01-.004-.004-.002a.093.093 0 0 0-.01-.003h-.002l-.003-.001-.009-.002h-.006l-.003-.001h-.004l-.002-.001h-.574a.156.156 0 0 0-.156.155v3.486c0 .086.07.155.156.155h.56c.087 0 .157-.07.157-.155v-2.07l1.6 2.16a.154.154 0 0 0 .039.038l.001.001.01.006.004.002a.066.066 0 0 0 .008.004l.007.003.005.002a.168.168 0 0 0 .01.003h.003a.155.155 0 0 0 .04.006h.56c.087 0 .157-.07.157-.155V4.918a.156.156 0 0 0-.156-.156h-.561Zm3.815.717v-.56a.156.156 0 0 0-.155-.157h-2.242a.155.155 0 0 0-.108.044h-.001l-.001.002-.002.003a.155.155 0 0 0-.044.107v3.486c0 .041.017.08.044.107l.002.003.002.002a.155.155 0 0 0 .108.043h2.242c.086 0 .155-.07.155-.156v-.56a.156.156 0 0 0-.155-.157H11.81v-.589h1.525c.086 0 .155-.07.155-.156v-.56a.156.156 0 0 0-.155-.157H11.81v-.589h1.525c.086 0 .155-.07.155-.156Z"/>
                            </svg>
                        </a>
                    </li>
                    <li v-if="button.tel">
                        <a class="iconbutton-tel tw-text-2xl" :href="`tel:${button.tel}`" target="__blank">
                            <i class="fa fa-phone"></i>
                        </a>
                    </li>
                    <li v-if="button.facebook">
                        <a class="iconbutton-facebook tw-text-2xl" :href="button.facebook" target="__blank">
                            <i class="fa fa-facebook"></i>
                        </a>
                    </li>
                </ul>
            </div>
            
        </div>

        
    </div>
</template>

<script>
    export default {
        props: [ 'button' ],

        data() {
            return {
                openOptions: false,
            }
        },
        
    }
</script>

<style lang="scss" scoped>  
    .fab-container{
        position: fixed;
        bottom: 20px;
        right: 20px;
        cursor: pointer;
    }
    .iconbutton {
        width: 50px;
        height: 50px;
        border-radius: 100%;
        box-shadow: rgb(255 255 255 / 15%) 0px 0px 10px;
    }
    .iconbutton-facebook {
        width: 50px;
        height: 50px;
        border-radius: 100%;
        background: #3b5998;
    }
    .iconbutton-tel {
        width: 50px;
        height: 50px;
        border-radius: 100%;
        background: #FF4F79;
    }
    .iconbutton-line {
        width: 50px;
        height: 50px;
        border-radius: 100%;
        background: #00c300;
    }
    .button {
        width: 60px;
        height: 60px;
        background: #FDD835;
        transition: all 0.4s ease;
        transform: rotate(30deg);
    }
    .button.active {
        transform: rotate(0deg);
    }
    .options.active {
        opacity: 0;
        transition: all 0.4s ease;
    }
    
    .iconbutton i,
    .iconbutton-facebook i,
    .iconbutton-tel i,
    .iconbutton-line i {
        display: flex;
        align-items: center;
        justify-content: center;
        height:  100%;
        color: white;
    }
    .icon-button {
        color: white;
        height:  100%;
    }
    .options li{
        display: flex;
        justify-content: flex-end;
        padding: 5px;
    }
    .options {
        list-style-type: none;
        position: absolute;
        bottom: 70px;
        right: 0px;
        opacity: 1;
        transition: all 0.4s ease;
    }
    .btn-label{
        padding: 2px 5px;
        margin-right: 10px;
        align-self: center;
        user-select: none;
    }
    @media (max-width: 640px) {

    }
</style>